export enum DocumentStatus {
    New,
    Uploaded
}